import { SerializedComponent } from '../../../machines';
import { AllocationDetails } from '../../../machines/addOnsConfiguration/types';

export const sortComponentAllocations = (
  componentsAllocations: AllocationDetails[],
  components: SerializedComponent[]
) => {
  const sortedAllocations = {
    recurringAllocations: [] as AllocationDetails[],
    oneTimeAllocations: [] as AllocationDetails[],
  };

  componentsAllocations.forEach((allocation) => {
    const component = components.find(
      (component) => component.id === allocation.id
    );

    if (component) {
      const { recurring, name, type, unitName } = component;

      if (recurring) {
        sortedAllocations.recurringAllocations.push({
          ...allocation,
          unitName,
          name,
          type,
        });
        return;
      }

      sortedAllocations.oneTimeAllocations.push({
        ...allocation,
        unitName,
        name,
        type,
      });
    }
  });

  return sortedAllocations;
};
